import { useEffect, useRef } from "react";

export const trackEvent = (name, params = {}, callback) => {
  if (typeof window.gtag !== "function") {
    if (callback) callback();
    return;
  }
  if (callback) {
    let done = false;
    const go = () => {
      if (!done) {
        done = true;
        callback();
      }
    };
    window.gtag("event", name, { ...params, event_callback: go, event_timeout: 800 });
    setTimeout(go, 900);
    return;
  }
  window.gtag("event", name, params);
};

export const trackPageView = (path) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", { page_path: path, page_title: document.title });
  }
};

export const useTrackOnVisible = (ref, eventName, params = {}) => {
  const fired = useRef(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || fired.current) return undefined;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !fired.current) {
          fired.current = true;
          trackEvent(eventName, params);
          obs.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref, eventName]);
};
